import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { PurchaseCreditTermsContainerModel } from "../../../../../../models/aggregates/erp/credit";
import { BaseApiTemplateService } from "../../shared/base-api-template-service.model";
import { Core2Config } from "../../shared/core2Config";
import { ApiResponseModel, ApiVisa } from "../../shared";
import { Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class PurchaseCreditTermsService extends BaseApiTemplateService<PurchaseCreditTermsContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "fi/entity-purchase-credit-terms/backoffice-ep";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "fi/entity-purchase-credit-terms/backoffice-ep";
    this.httpClient = http;
  }

  postMultiEntityPurchaseCreditTerms(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let customUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      customUrl = this.apiUrl + "/add-multi-credit-terms";
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      customUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
}
